import { api, setConfig, DELETE_USER_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const deleteAccount = (data: PropertyType): Promise<string | void> =>
	api.post('/user/delete', mapEntityToApi(data), setConfig(data)).then(() => {
		return DELETE_USER_MESSAGE;
	});
